import { render } from "./void-btn.vue?vue&type=template&id=08929754&scoped=true"
import script from "./void-btn.vue?vue&type=script&lang=js"
export * from "./void-btn.vue?vue&type=script&lang=js"

import "./void-btn.vue?vue&type=style&index=0&id=08929754&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08929754"]])

export default __exports__